import { defineStore } from 'pinia';
import clientApi from '@/app/features/ams/client/client-service';
import attributesApi from '@/app/features/ams/attributes/attributes-service';
import { Client } from '@/app/shared/types/models/client.interface';
import { ClientState } from '@/app/shared/types/stores/client-state.interface';
import { LuaCodingReferences } from '@/app/shared/types/models/lua-coding-references.interface';
import { useAuthStore } from '@/app/shared/stores/auth-store';

export const useClientStore = defineStore({
  id: 'clientStoreId',
  state: () =>
    ({
      selectedClient: {
        id: -1,
        description: '',
        clientName: '',
        createdBy: '',
        createdAt: 0,
        updatedAt: 0,
        updatedBy: '',
        dataSources: [],
        systems: [],
        reports: [],
      },
      clientList: [],
      attributeList: [],
      filterList: [],
      functionList: [],
      systemList: [],
    } as ClientState),
  // TODO: Getter should return computed or processed values, all this functions
  // return the same value as accessing the state directly
  getters: {
    getSelectedClient(): Client {
      return this.selectedClient;
    },
    getClientList(): Array<Client> {
      return this.clientList;
    },
    getFunctionList(): Array<any> {
      return this.functionList;
    },
    getAttributeList(): Array<any> {
      return this.attributeList;
    },
    getFilterList(): Array<any> {
      return this.filterList;
    },
    getSystemList(): Array<any> {
      return this.systemList;
    },
  },

  actions: {
    async fetchClientData() {
      // TODO:Migrate from callback to an async await call
      return new Promise((resolve, reject) => {
        clientApi
          .getClients()
          // TODO: Create an interface for this attribute or use an existing one
          .then((resp: any) => {
            this.clientList = resp.data.data || [];
            this.systemList = resp.data.data[0]?.systems?.map(
              // TODO: Create an interface for this attribute or use an existing one
              (system: any) => system.systemName
            );
            resolve(true);
          })
          // TODO: Create an interface for this attribute or use an existing one
          .catch((err: any) => {
            console.error('error retrieving client data: ', err);
            reject(err);
          });
      });
    },
    async setSelectedClient(client: Client) {
      this.selectedClient = client;
      const authStore = useAuthStore();
      await authStore.updateRoles(client.id, 'AMS');
    },
    async fetchAttributeFilterFunctionList(clientId: number) {
      try {
        const {
          data: { data },
        } = (await attributesApi.getAttributesFiltersFunctionsByClientId(
          clientId
        )) as { data: LuaCodingReferences };
        // TODO: Create an interface for this attribute or use an existing one
        this.attributeList = data.attributes?.map((attr: any) => attr);
        // TODO: Create an interface for this attribute or use an existing one
        this.filterList = data.filters?.map((filter: any) => filter);
        // TODO: Create an interface for this attribute or use an existing one
        this.functionList = data.functions?.map((func: any) => func);
        return true;
      } catch (err) {
        console.error(
          'error retrieving attributes, filters, functions list: ',
          err
        );
        throw err;
      }
    },
  },
});
